// Modules
import { createGlobalStyle } from 'styled-components'
import { getCustomTheme } from '@dasa-health/alma-react'
import { navTokens } from '@dasa-health/alma-tokens'

export const navTheme = getCustomTheme(navTokens)

export const global = createGlobalStyle`
    .grecaptcha-badge {
        width: 70px !important;
        overflow: hidden !important;
        transition: all 0.3s ease !important;
        bottom: 14px;
        right: 0px !important;
        visibility: hidden;
    }

    .grecaptcha-badge:hover {
        width: 256px !important;
    }

    body {
        overflow-y: hidden;
    }
`
